module.exports = __webpack_public_path__ + "imahe.png?4dd8e0198588974c70fd869307cd4cde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imahe.png
// module id = 664
// module chunks = 0